export const DEFAULT_APARTMENT_COMPARE: ApartmentCompare = {
  id: '',
  aptSeq: '',
  name: '',
  lawdCd: '',
  sidoName: '',
  sigunguName: '',
  aptName: '',
  excluUseAr: 0,
};

export interface ApartmentCompare {
  id: string;
  aptSeq?: string;     // 정적 데이터의 단지 고유 식별자 (기존 저장 데이터에는 없을 수 있음)
  name: string;        // 표시명
  lawdCd: string;      // 5자리 법정동코드 (시군구 수준)
  sidoName: string;
  sigunguName: string;
  aptName: string;     // 단지명 (API에서 반환된 이름 그대로)
  excluUseAr: number;  // 전용면적
}

export interface ApartmentSearchItem {
  aptSeq: string;
  aptName: string;
  dongName: string;
  excluUseAr: number;
  buildYear: number | null;
  households: number;
}

export interface ApartmentTransactionItem {
  yearMonth: string; // YYYY-MM
  price: number;     // 만원
}

export interface ApartmentCompareChartData {
  yearMonth: string;
  netAssetManwon: number | undefined; // 순자산 (만원), 해당 월 자산데이터 없으면 undefined
  aptPrice: number | undefined;       // 아파트 실거래가 (만원)
}
